



























import Vue, { PropType } from 'vue'

import { EventService } from '../../base/services/EventService'
import { PermutatorService } from '../widgets/base/permutator'
import { WidgetContainer } from '../widgets/container/WidgetContainerInterface'
import BasePanel from 'base/components/BasePanel.vue'
import ElementTreePanelRow from './ElementTreePanelRow.vue'
import ElementTreePanelRowControls from './ElementTreePanelRowControls.vue'

export default Vue.extend({
  components: {
    BasePanel,
    ElementTreePanelRow,
    ElementTreePanelRowControls
  },
  props: {
    container: {
      type: Object as PropType<WidgetContainer>,
      required: true,
      default: {}
    }
  },
  computed: {
    currentDashboardTemplate(): string {
      return this.$store.state.dashboard.selectedTemplate
    },
    isExpanded(): boolean {
      return this.selectedWidgetUUID.indexOf(this.container.wbUUID!) > -1
    }
  },
  data() {
    return {
      selectedWidgetUUID: [] as string[],
      isHovering: false
    }
  },
  methods: {
    onHover() {
      this.isHovering = true
    },
    onUnhover() {
      this.isHovering = false
    },
    onSelectWidget(component: any) {
      this.selectedWidgetUUID = []

      if (!component) return

      const widget = component.widget

      if (!widget) return

      const uuidPath = PermutatorService.getParentUUIDs(widget.wbUUID)

      if (!uuidPath.length) return

      this.selectedWidgetUUID = uuidPath.reverse()
    }
  },
  created() {
    EventService.$on('widget-select', this.onSelectWidget)
  },
  destroyed(): void {
    EventService.$off('widget-select', this.onSelectWidget)
  }
})
